import React, { useState } from 'react';
import './courses.css';
import CourseRegistration from './CourseRegistration';

const Courses = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showAllCourses, setShowAllCourses] = useState(false);
  
  const courses = [
    {
      title: "Web Development",
      description: "Learn HTML, CSS, JavaScript, and modern frameworks",
      duration: "3 months"
    },
    {
      title: "Programming Fundamentals",
      description: "Master the basics of programming with Python",
      duration: "3 months"
    },
    {
      title: "Data Science",
      description: "Explore data analysis and machine learning",
      duration: "3 months"
    },
    {
      title: "Digital Marketing",
      description: "Master SEO, social media, and online advertising",
      duration: "2 months"
    },
    {
      title: "Mobile App Development",
      description: "Build iOS and Android apps with React Native",
      duration: "4 months"
    },
    {
      title: "UI/UX Design",
      description: "Create beautiful and functional user interfaces",
      duration: "3 months"
    },
    {
      title: "Cloud Computing",
      description: "Master AWS, Azure, and cloud technologies",
      duration: "3 months"
    },
    {
      title: "Cyber Security",
      description: "Learn network security and ethical hacking",
      duration: "4 months"
    }
  ];

  const handleEnrollClick = (course) => {
    setSelectedCourse(course);
  };

  const displayedCourses = showAllCourses ? courses : courses.slice(0, 6);

  return (
    <section className="courses" id="courses">
      <h2>Our Courses</h2>
      <div className="courses-container">
        <div className="courses-grid">
          {displayedCourses.map((course, index) => (
            <div 
              className="course-card" 
              key={index}
              style={{"--card-index": index}}
            >
              <h3>{course.title}</h3>
              <p>{course.description}</p>
              <span className="duration">Duration: {course.duration}</span>
              <button 
                className="btn enroll-btn"
                onClick={() => handleEnrollClick(course)}
                style={{marginTop: '1rem'}}
              >
                Enroll Now
              </button>
            </div>
          ))}
        </div>
        {!showAllCourses && courses.length > 6 && (
          <button 
            className="btn explore-btn"
            onClick={() => setShowAllCourses(true)}
          >
            Explore More Courses
          </button>
        )}
      </div>

      {selectedCourse && (
        <CourseRegistration
          course={selectedCourse}
          onClose={() => setSelectedCourse(null)}
        />
      )}
    </section>
  );
};

export default Courses;
